<template>
  <v-flex
    multiview-body-flex-wrapper
    tall-content-wrapper
    @scroll="debounceScroll"
    ref="wrapper">
    <v-row no-gutters justify="center" class="multiview-browser-body">
      <resizeable-thumbnail
        v-for="image in currentRecords"
        :key="image.imgKey"
        :image="image"
        :scale="scale"
        @click="selectImage(image)"
        @clickCheckbox="selectImageProofsheet(image)"></resizeable-thumbnail>
    </v-row>
  </v-flex>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import disableScroll from "../mixins/disableScroll";
import tooltipGenerator from "../mixins/TooltipGenerator";
import resizeableThumbnail from "../misc/ResizeableThumbnail";

export default {
  name: "proofsheetModalBody",
  components: { resizeableThumbnail },
  mixins: [tooltipGenerator, disableScroll],
  props: ["scale"],
  computed: {
    ...mapGetters([
      "ptSrNo",
      "proofsheetContext",
      "proofsheetEyeFilter",
      "proofsheetFilterOption",
      "selectedImages",
      "proofsheetExams",
      "filteredProofsheetImages",
    ]),
    possibleRecords() {
      return this.filteredProofsheetImages;
    },
  },
  data() {
    return {
      batchSize: 40,
      maxRecords: 120,
    };
  },
  methods: {
    ...mapActions(["selectImageProofsheet", "updateCurrentImagesProofsheet"]),
    selectImage(image) {
      this.$store.dispatch("openBrowserForImage", image);
    },
    getNthElement(n) {
      let selector = `.resizeable-thumbnail:nth-child(${n + 1})`;
      return document.querySelector(selector);
    },
    reportUpdatedBounds(bounds) {
      this.updateCurrentImagesProofsheet(bounds);
    },
  },
};
</script>